// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2qTgK","modalForm":"UpgradeEpcsModal_modalForm__3J-i-","modalFooter":"UpgradeEpcsModal_modalFooter__3ie5C"};